<template>
  <div class="reciever-form  ">
    <div class="flex mb-20">
      <div class=" f-c-blue pointer mr-10" @click="visible2 = true">选择收件人</div>
      <div class="f-c-blue pointer" @click="visible1 = true">智能识别地址</div>
    </div>
    <a-form-model ref="form" class="my-form" layout="inline" :model="form" :rules="rules">
      <div class="flex">
        <a-form-model-item class=" my-form-item " prop="contactName">
          <span slot="label">姓　　名</span>
          <a-input
            v-model="form.contactName"
            class="w-200"
            placeholder="请输入姓名"
          />
        </a-form-model-item>
        <a-form-model-item class="my-form-item  " prop="companyName">
          <span slot="label">公　　司</span>
          <a-input
            v-model="form.companyName"
            class="w-200"
            placeholder="请输入公司名称"
          />
        </a-form-model-item>
      </div>
      <div class="flex">
        <a-form-model-item class=" my-form-item " prop="mobile">
          <span slot="label">联系方式</span>
          <a-input
            v-model="form.mobile"
            class="w-200"
            placeholder="请输入手机号/固话"
          />
        </a-form-model-item>
        <a-form-model-item class=" my-form-item " prop="phone">
          <!-- <span slot="label">固定电话</span>
          <a-input
            v-model="form.phone"
            class="w-200"
            placeholder="请输入固定电话"
          /> -->
        </a-form-model-item>
      </div>
      <a-form-model-item class="my-form-item  " prop="addrObj">
        <span slot="label">收件地址</span>
        <Addr class="mt-8 my-addr" :result.sync="form.addrObj" />
      </a-form-model-item>
      <div class="flex">
        <a-form-model-item class="my-form-item pt-8" prop="cargoName">
          <span slot="label">物品类型</span>
          <div class="flex h-100p a-center">
            <div v-for="(i,index) in goods" :key="i.name" class="goods mr-10" :class="gIndex === index?'c-active':''" @click="gIndex = index">
              {{ i.name }}
            </div>
          </div>
        </a-form-model-item>
      </div>
      <div class="flex  mt-10 pl-10">
        <a-form-model-item class="my-form-item  ">
          <span slot="label">预估重量</span>

          <a-input v-model="form.weight" class="w-180" type="number" suffix="KG" />

        </a-form-model-item>
      </div>
    </a-form-model>

    <div class="mt-20 t-center">
      <a-button @click="reset">取消</a-button>
      <a-button type="primary" @click="save">保存</a-button>
    </div>
    <AddrList :key="2" :address-type="2" :visible.sync="visible2" @ok="ok2" />
    <Recognition :visible.sync="visible1" @success="setInfo" />
  </div>
</template>
<script>

import Addr from './addr'
import validate from '@framework/utils/biz-validate'
import AddrList from '@/components/addrList'
import Recognition from '@/components/recognition'

export default {
  components: {
    Addr, AddrList, Recognition
  },
  props: {
    // addressType: {
    //   type: Number,
    //   default: 1
    // },
    mode: {
      type: Number,
      default: 1 // 1为新增，2为编辑
    },
    info: {
      type: Object,
      default: null
    }

  },
  data() {
    // const validatePhone = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请输入正确的用户名'))
    //   } else {
    //     callback()
    //   }
    // }
    // const validateMobile = (rule, value, callback) => {
    //   if (!validate.mobile.pattern.test(value)) {
    //     callback(new Error(validate.mobile.msg))
    //   } else {
    //     callback()
    //   }
    // }
    const validateMobile = (rule, value, callback) => {
      if (!this.$utils.rules.mobileOrPhone.pattern.test(value)) {
        callback(new Error(this.$utils.rules.mobileOrPhone.msg))
      } else {
        callback()
      }
    }
    const validateAddr = (rule, value, callback) => {
      if (!value || !value.provinceCode) {
        callback(new Error('请选择省市区'))
      } else if (!value || !value.addressDetail) {
        callback(new Error('请填写详细地址'))
      } else {
        callback()
      }
    }

    return {
      visible1: false,
      visible2: false,
      gIndex: '',
      goods: [{ name: '食品' }, { name: '电子产品' }, { name: '生活用品' }, { name: '服饰' }, { name: '文件' }, { name: '其他' }],
      addr: null,
      form: {
        weight: 1,
        cargoName: '',
        addrObj: null,
        'addressDetail': '',
        'addressType': 2,
        'areaCode': '',
        'areaName': '',
        'cityCode': '',
        'cityName': '',
        'companyName': '',
        'contactName': '',
        'mobile': '',
        'phone': '',
        'provinceCode': '',
        'provinceName': ''
      },
      rules: {
        cargoName: [{ required: true, message: '请选择物品类型' }],
        contactName: [{ required: true, message: '请输入姓名' }],
        mobile: [{ required: true, validator: validateMobile }],
        addrObj: [{ required: true, validator: validateAddr }]
      }
    }
  },
  watch: {
    gIndex(n) {
      this.form.cargoName = this.goods[n].name
      this.$refs.form.validateField('cargoName')
    },
    info(n) {
      this.gennerateAddrObj(n)
      this.setInfo(n)
    }
  },
  created() {
    // this.form.addressType = this.addressType
    if (this.info) {
      this.gennerateAddrObj(this.info)
      this.setInfo(this.info)
      // Object.assign(this.form, this.info)
    }
  },
  methods: {
    setInfo(info) {
      this.ok2(info)
    },
    ok2(info) {
      this.form.contactName = info.contactName || info.name
      this.form.mobile = info.mobile
      this.form.phone = info.phone
      this.gennerateAddrObj(info)
      this.form.addrObj = { ...info.addrObj }
      this.form.companyName = info.companyName
      this.form.weight = info.weight || 1
      this.form.cargoName = info.cargoName || '其他'
      const index = this.goods.findIndex(el => el.name === info.cargoName)
      index === -1?this.gIndex = 5:this.gIndex = index
      
      this.$nextTick(() => {
        this.$refs.form.validateField('contactName')
        this.$refs.form.validateField('mobile')
        // this.$refs.form.validateField('rname')
        this.$refs.form.validateField('addrObj')
      })
    },
    gennerateAddrObj(n) {
      const addrObj = {
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        addressDetail: '',
        areaCode: '',
        areaName: ''
      }
      Object.keys(addrObj).forEach(el => {
        addrObj[el] = n[el]
      })
      addrObj.addressDetail = n.addressDetail || n.address
      n.addrObj = addrObj
    },
    reset() {
      this.$emit('cancel')
    },
    save() {
      this.$refs.form.validate(async(v) => {
        if (v) {
          const params = { ...this.form }
          delete params.addrObj

          Object.assign(params, this.form.addrObj)
          params.address = params.addressDetail
          params.tel = params.phone
          params.name = params.contactName
          params.isSaveAddr = null
          delete params.addressType
          delete params.addressDetail
          delete params.phone
          delete params.contactName
          this.$emit('success', params)
        }
      })
    //
    }
  }
}
</script>
<style lang="scss">
.reciever-form{
   .goods{
    border: 1px solid rgba(0,0,0,0.15);
    line-height: 32px;
    text-align: center;
    height: 32px;
    padding: 0 16px 0 16px;
    cursor: pointer;
  }
    .my-addr{
        .ant-cascader-picker{
            width: 200px;
        }
        .ant-input{
            width: 295px;
        }
}
}

</style>
